import classNames from "classnames";
import { FC, ReactNode, RefObject, useRef } from "react";
import { Icon } from "../icon/icon";

const NavItem: FC<{
  parentRef: RefObject<null>;
  children: ReactNode;
  onClick: () => void;
  className: string;
}> = ({ parentRef, children, onClick = () => {}, className }) => {
  const ref = useRef(null);

  return (
    <button
      type="button"
      ref={ref}
      onClick={() => {
        if (ref.current && parentRef.current) {
          const ref_ = ref.current as HTMLButtonElement;
          const parentRef_ = parentRef.current as HTMLDivElement;

          const relativeLeft =
            ref_.getBoundingClientRect().left -
            parentRef_.getBoundingClientRect().left +
            parentRef_.scrollLeft;

          parentRef_.scrollLeft = relativeLeft - 32;

          onClick();
        }
      }}
      className={className}
    >
      {children}
    </button>
  );
};

export const TabSelect: FC<{
  tabs: (
    | {
        title: string | ReactNode;
        to: string;
        onClick: (val: string) => void;
        onRemove?: (val: string) => void;
        className?: string;
      }
    | undefined
  )[];
  className?: string;
  tabClassName?: string;
  activeTab?: string[];
}> = ({ tabs = [], className = "", tabClassName = "", activeTab }) => {
  const navRef = useRef(null);

  return (
    <div
      className={classNames(
        `hide-scroll-bar flex flex-row gap-2 overflow-x-scroll`,
        `w-fit !scroll-smooth transition-all duration-1000`,
        className,
      )}
      ref={navRef}
    >
      {tabs
        .filter((item) => item !== undefined)
        .map(({ title, to, onClick, onRemove, className }, i) => {
          const key = `TabNav-${i}-${title}`;

          return (
            <NavItem
              parentRef={navRef}
              key={key}
              className={classNames(
                `relative flex min-w-max cursor-pointer items-center gap-1 text-center text-sm font-bold transition-all duration-300`,
                "flex items-center gap-1 text-sm font-bold text-grey-950",
                "rounded-full border border-grey-200 px-3 py-2",
                tabClassName,
                className,
              )}
              onClick={() => {
                onClick(to);
              }}
            >
              {title}

              {onRemove && (
                <div
                  className="w-fit"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onRemove(to);
                  }}
                >
                  <Icon
                    svg="close-icon"
                    width={16}
                    height={16}
                    className="text-grey-600"
                  />
                </div>
              )}
            </NavItem>
          );
        })}
    </div>
  );
};
